<template>
  <transition name="fade">
    <div class="editor" v-if="isEditorActive">
      <CloseButton @close="closeEditor" />
      <component :is="editorComponent" />
    </div>
  </transition>
</template>

<script>
import { state } from "./data";

export default {
  components: {
    CloseButton: () => import("./editor-close"),
    EditExam: () => import("./subcomponents/editor-edit-exam.vue"),
  },
  computed: {
    isEditorActive() {
      return state.local.editor.active;
    },
    editorComponent() {
      return state.local.editor.name;
    }
  },
  methods: {
    closeEditor() {
      state.local.editor = { active: false };
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
.editor {
  position: absolute !important;
  display: flex;
  width: 100%;
  overflow-y: scroll;
  height: 100%;
  padding: 10%;
  background: #efefefd9;
  background: rgba(236, 236, 236, 0.90) !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 49999;
  background: rgba(236, 236, 236, 0.65);
  backdrop-filter: blur(6px);
  // &:before {
    // box-shadow: inset 0 0 2000px rgba(255, 255, 255, .5);
    // filter: blur(10px);
  // }

  & .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.fade-enter-active {
  transition: all .2s ease;
}
.fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
